import { Group, Select, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

import { useAutomationWizardController } from '../../controller';

import type { ActionCardProps } from './ActionCard';
import { renderFieldItem, selectedFieldStyle } from './components';

export const CopyFieldToField = ({ actionIndex }: ActionCardProps) => {
  const { t } = useTranslation();
  const {
    form,
    actions: { getSourceFieldProps, getDestinationFieldProps },
  } = useAutomationWizardController();

  return (
    <Stack>
      <Text size="sm" fw={500}>
        {t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.COPY_FIELD_TO_FIELD)}
      </Text>
      <Group gap="xl" align="start">
        <Select
          label={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.SOURCE_FIELD_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.FIELD_PLACEHOLDER)}
          renderOption={renderFieldItem}
          allowDeselect={false}
          clearable
          searchable
          classNames={{
            option: selectedFieldStyle,
          }}
          {...form.getInputProps(`actions.${actionIndex}.sourceField`)}
          {...getSourceFieldProps(actionIndex)}
        />
        <Select
          label={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.DESTINATION_FIELD_LABEL)}
          placeholder={t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.FIELD_PLACEHOLDER)}
          renderOption={renderFieldItem}
          allowDeselect={false}
          clearable
          searchable
          classNames={{
            option: selectedFieldStyle,
          }}
          {...form.getInputProps(`actions.${actionIndex}.destinationField`)}
          {...getDestinationFieldProps(actionIndex)}
        />
      </Group>
    </Stack>
  );
};
